import classnames from 'classnames';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
	addToBasketEvent,
	gotProductsInBasket,
} from '../../../actions/lister-actions';
import { checkBasket } from '../../../utilities/basket-utilities';
import {
	addToBasket,
	navigateToBasket,
	updateBasket,
} from '../../../utilities/lister-utilities';
import AddToBasketLoadingSpinner from './AddToBasketLoadingSpinner';
import TRANSLATIONS from './translations@default.json';

export const AddToBasketButton = ({
	classes,
	BuyButtonModel: { ProductCode } = {},
	AddToBasketTimeStamp,
	AddToBasketHashToken,
	CategoryId,
}) => {
	const { timeStamps, productsInBasket, isDealsPage } = useSelector(
		(state) => state
	);

	const { PerProductAddToBasketTimeStampHashEnabled, CustomCategoriesEnabled } =
		useSelector((state) => state.featureSwitches);

	// const productIsInTheBasket = productsInBasket?.list?.includes(ProductCode);

	const matchBasketEncodedProductCode = ProductCode?.replace(/\s/g, '+');
	const upperCaseProductsInBasket = productsInBasket?.list?.map(product => product.toUpperCase()); 
	const productIsInTheBasket = upperCaseProductsInBasket?.includes(matchBasketEncodedProductCode);

	const [addedToBasket, setAddedToBasket] = useState(productIsInTheBasket);
	const [loading, setLoading] = useState(false);

	const dispatch = useDispatch();

	const handleAddToBasket = () => {
		const amountOfProductsInBasket = productsInBasket?.number;

		setLoading(true);

		if (PerProductAddToBasketTimeStampHashEnabled) {
			timeStamps.addToBasketTimeStamp = AddToBasketTimeStamp;
			timeStamps.addToBasketTimeStampHash = AddToBasketHashToken;
		}

		const isPurchasingWithSwitch24 =
			window.AO?.isPurchasingWithSwitch24 ?? false;

		addToBasket(ProductCode, timeStamps, { isPurchasingWithSwitch24 })
			.then((response) => {
				updateBasket(response.TotalNumberOfItems);
				setLoading(false);
				setAddedToBasket(true);
				dispatch(gotProductsInBasket(checkBasket()));

				if (amountOfProductsInBasket > 0) {
					dispatch(addToBasketEvent('listerAddToBasket', ProductCode));
				} else {
					dispatch(
						addToBasketEvent('listerAddToBasketInitialProduct', ProductCode)
					);
				}

				navigateToBasket(response.RedirectLocation);
			})
			.catch(function (error) {
				throw new Error(error);
			})
			.finally(function () {
				window.AO = window.AO || {};
				window.AO.isPurchasingWithSwitch24 = false;
			});
	};

	// CategoryId 230 is for add on care products, e.g. hob cleaner
	if (!ProductCode || CategoryId === 230) {
		return null;
	}

	if (addedToBasket) {
		return (
			<a
				href={`${window.checkoutUrlPrefix}/shoppingbasket.aspx`}
				className={classnames(
					classes,
					'block cta cta-inactive btn btn-inactive cursor-pointer text-center flex justify-center',
					{
						'z-20': isDealsPage,
						'ml-2 xl:ml-0': CustomCategoriesEnabled,
					}
				)}
				data-tag-name="go-to-basket-button"
				data-testid="go-to-basket-button">
				{TRANSLATIONS.goToBasketButton}
			</a>
		);
	}

	return (
		<button
			type="button"
			className={classnames(
				classes,
				'cta btn btn-primary text-center w-full flex justify-center',
				{
					'z-20': isDealsPage,
				}
			)}
			onClick={handleAddToBasket}
			data-testid="add-to-basket-button">
			{loading ? <AddToBasketLoadingSpinner /> : TRANSLATIONS.addToBasketButton}
		</button>
	);
};

export default AddToBasketButton;
